import { Link } from "react-router-dom"
import { Card, CardBody, Col, Table } from "reactstrap"

import { Loading } from "components"
import { getTickets } from "services/tickets"
import { formatTicketPaymentMethods } from "utils/payment-methods"
import useDashboardQuery from "../useDashboardQuery"

const formatMoney = (value) =>
  new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 2,
  }).format(Number(value || 0))

const formatTime = (value) => {
  if (!value) return "--"

  const date = new Date(String(value).replace("Z", ""))

  if (Number.isNaN(date.getTime())) return "--"

  return new Intl.DateTimeFormat("es-MX", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).format(date)
}

const DashboardRecentTickets = () => {
  const recentTicketsQuery = useDashboardQuery(["dashboard-recent-tickets"], () => getTickets({ per_page: 10 }), {
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  })

  const recentTickets = recentTicketsQuery.data?.results ?? []

  return (
    <Card className="shadow-sm border-0 h-100">
      <CardBody className="p-4">
        <div className="mb-3">
          <h5 className="mb-1">Últimos 10 tickets</h5>
        </div>

        <div className="table-responsive">
          <Table className="mb-0 align-middle table-hover-effect table-interactive" hover>
            <thead className="table-light">
              <tr>
                <th className="text-nowrap">Folio</th>
                <th className="text-nowrap">Hora</th>
                <th className="text-nowrap">Cliente</th>
                <th className="text-nowrap text-end">Total</th>
                <th className="text-nowrap">Método de pago</th>
              </tr>
            </thead>
            <tbody>
              {recentTicketsQuery.isLoading ? (
                <tr>
                  <td colSpan={5} className="py-4 text-center">
                    <Loading isLoading size={1.5} />
                  </td>
                </tr>
              ) : recentTicketsQuery.isError ? (
                <tr>
                  <td colSpan={5} className="py-4 text-center text-muted">
                    No se pudieron cargar los tickets.
                  </td>
                </tr>
              ) : recentTickets.length > 0 ? (
                recentTickets.map((ticket) => (
                  <tr key={ticket.id || ticket.folio}>
                    <td className="fw-semibold text-nowrap">{ticket.folio || "--"}</td>
                    <td className="text-nowrap text-muted">{formatTime(ticket.date)}</td>
                    <td>{ticket?.customer?.name || "Mostrador"}</td>
                    <td className="text-nowrap text-end fw-semibold">{formatMoney(ticket.total)}</td>
                    <td>{formatTicketPaymentMethods(ticket)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5} className="py-4 text-center text-muted">
                    No hay tickets recientes.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        <Col xs="12" className="d-flex justify-content-end py-1">
          <Link to="/sales" className="btn btn-primary px-4 py-2">
            Ver tickets
          </Link>
        </Col>
      </CardBody>
    </Card>
  )
}

export default DashboardRecentTickets
